import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {isAdmin} from '../../../utils/auth';

import {csvTypeValidation, imageTypeValidation, videoTypeValidation} from '../../../utils/fileValidation';

import * as commonActionCreators from '../../../actions/common';
import * as headerActionCreators from '../../../actions/header';
let allActionCreators = Object.assign({}, commonActionCreators, headerActionCreators);


class Dashboard extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {}
	}

	componentWillMount() {
    
  }

  userNav(page) {
    this.context.router.push('/' + page);
  }


	render() {
		return <div className='Dashboard'>
      <div className='welcomeMessage'>
        {this.props.user.user ? 
          <span>Welcome, {this.props.user.user.first_name}!</span> :
          <span>Welcome!</span>
        }
      </div>

      <div className='tileWrapper'>
        <div 
          className='genericTile'
          onClick={() => this.userNav('transfers')}>
          <div className='textCover'>
            <img src='/img/icons/home/open_tran.png' />
            <div className='textCoverIcon'>
              <div className='iconWrapper'><i className={"fa-solid fa-leaf"}></i></div>
            </div>
          </div>
          <div className='textLabel'>
            <div className='textTitle'>Natural Diamonds</div>
          </div>
        </div>
        <div 
          className='genericTile'
          onClick={() => this.userNav('lab/transfers')}>
          <div className='textCover'>
            <img className='show' src='/img/icons/home/lgd1.svg' />
            <div className='textCoverIcon'>
              <div className='iconWrapper'><i className={"fa-solid fa-flask-vial"}></i></div>
            </div>
          </div>
          <div className='textLabel'>
            <div className='textTitle'>LGD</div>
          </div>
        </div>
      </div>
		</div>;
	}
}
export default Dashboard;

function mapStateToProps(state) {
  return {
    header: state.header,
    user: state.user,
  };
}

export const DashboardContainer = connect(
  mapStateToProps,
  allActionCreators
)(Dashboard);